/**
 * Component: A11y Decorative Image Helper
 * 
 */
'use strict';

export class A11yImgHelper {

  constructor() {}

  init() {
    this.init_a11y_img_helper();
  }

  init_a11y_img_helper = () => {
    const imagesWithoutAltText = document.querySelectorAll('img:not([aria-describedby])');
    const svgImages = document.querySelectorAll('svg');

    imagesWithoutAltText.forEach((image) => {
      // console.table( [ [ 'source', image.src ], [ 'alt text', image.alt ] ] );

      // Check for presence of alt attribute
      if ( image.hasAttribute('alt') ) {
        if ( image.alt == '' ) {
          // Add aria-hidden to image
          image.setAttribute('aria-hidden', 'true');
        } else {
          // If image is SVG mime type, set role="img" (best support)
          if ( image.src.includes('.svg') ) {
            image.setAttribute('role', 'img');
          }
        }
      } else {
        // Add empty alt attribute
        image.setAttribute('alt', '');
        // Add aria-hidden to image
        image.setAttribute('aria-hidden', 'true');
      }
    });

    svgImages.forEach((svg) => {
      const svgTitle = svg.querySelectorAll('title');

      // Check for presence of title child element
      if ( svgTitle.length > 0 ) {
        // Add role="img" to svg
        svg.setAttribute('role', 'img');
        // If ID is present, set `aria-labelledby` to ID value
        if ( svgTitle[0].id ) {
          svg.setAttribute('aria-labelledby', svgTitle[0].id);
        }
      } else {
        // Add aria-hidden to svg
        svg.setAttribute('aria-hidden', 'true');
      }
    });

  }
}
